<template>
    <canvas ref="canvas">
    </canvas>
</template>

<script>
import Chart from "chartjs";
export default {
  props: {
    dates: Array
  },
  watch: {
    async config(config) {
      console.log(config);
      await this.$nextTick();
      const ctx = this.$refs.canvas.getContext("2d");
      if (this.chart) {
        this.chart.update({
          duration: 800,
          easing: "easeOutBounce"
        });
      } else {
        this.chart = new Chart(ctx, config);
      }
    }
  },
  computed: {
    histogram() {
      const histogram = {};
      let min_date = null;
      let max_date = null;
      this.dates.forEach(function(date) {
        if (!min_date || date < min_date) {
          min_date = date;
        }
        if (!max_date || date > max_date) {
          max_date = date;
        }
        histogram[date] = histogram[date] ? histogram[date] + 1 : 1;
      });
      const data = [
        {
          x: new Date("2019-03-01"),
          y: 3
        }
      ];
      for (
        let d = new Date(min_date);
        d <= new Date(max_date);
        d.setDate(d.getDate() + 1)
      ) {
        const date = d.toISOString().split("T")[0];
        data.push({
          x: new Date(date),
          y: histogram[date] ? histogram[date] : 0
        });
      }
      return data;
    },
    config() {
      return {
        type: "line",
        data: {
          datasets: [
            {
              label: "Count",
              backgroundColor: "#FF0000A0",
              borderColor: "#FF0000",
              fill: false,
              data: this.histogram
            }
          ]
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Birthday"
          },
          scales: {
            xAxes: [
              {
                type: "time",
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Date"
                },
                ticks: {
                  major: {
                    fontStyle: "bold",
                    fontColor: "#FF0000"
                  }
                }
              }
            ],
            yAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Count"
                }
              }
            ]
          }
        }
      };
    }
  }
};
</script>
